import AdminCertificatesSettingsPanel from "../components/certificates-settings/AdminCertificatesSettingsPanel";

const AdminCertificatesSettingsPage = () => {
  return <AdminCertificatesSettingsPanel />;
};

export default AdminCertificatesSettingsPage;
